import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from "../../../../shared/models/user";
import {applicationType} from "../team-users.component";

@Component({
    selector: 'app-member',
    templateUrl: './member.component.html',
    styleUrls: ['./member.component.scss'],
    standalone: false
})
export class MemberComponent implements OnInit {
  @Input() member: User;
  @Input() hideFunctions: boolean = false;
  @Input() hideAvatar: boolean = false;
  @Input() projectLocked: boolean = false;
  @Input() alreadyMember: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() applicationType: number;
  appType = applicationType;
  @Output() changeValue: EventEmitter<User> = new EventEmitter<User>();
  @Output() addSignal: EventEmitter<User> = new EventEmitter<User>();
  @Output() deleteSignal: EventEmitter<User> = new EventEmitter<User>();

  editAccess: boolean = false;
  commentAccess: boolean = false;

  editAccessTooltip: string = "Users can find and edit projects that they have this permission level for.";
  commentAccessTooltip: string = "Users can view and comment projects that they have this permission level for.";
  readAccessTooltip: string = "Users can find and view projects that they have this permission level for.";

  firstName: string = "";
  lastName: string = "";

  constructor() { }

  ngOnInit() {
    if(this.projectLocked) {
      this.hideFunctions = true;
    }
  }

  expandToggle() {
    if( !this.hideFunctions ) {
      this.member.expanded = !this.member.expanded;
    }
  }

  changeUserAccess() {
    this.member.individualAccess.allowEdit = !this.member.individualAccess.allowEdit;
    this.changeValue.emit(this.member);
  }

  setUserAccess(allowEdit: boolean, allowComment: boolean){
    this.member.individualAccess.allowComment = allowComment;
    this.member.individualAccess.allowEdit = allowEdit;
    this.changeValue.emit(this.member);
  }
  deleteUser() {
    this.deleteSignal.emit(this.member);
  }


  setNewUserAccess(obj: {editAccess: boolean, commentAccess: boolean}) {
    this.editAccess = obj.editAccess;
    this.commentAccess = obj.commentAccess;
  }
  addUser() {
    this.member.individualAccess.allowComment = this.editAccess || this.commentAccess;
    this.member.individualAccess.allowEdit = this.editAccess;
    this.addSignal.emit(this.member);
  }
}
